export default __webpack_public_path__ + "static/media/16.3cbe43b5.jpeg";